import { Route, Redirect } from "react-router-dom";
import { isAuthenticated } from "./../pages/UserFunctions";

const PrivateRoute = ({component: Component, restricted, ...rest}) => {
    return (

        // Show the component only when the user is logged in
        // Otherwise, redirect the user to /signin page
        <Route {...rest} render={props => (
            isAuthenticated() ?
                <Component {...props} />
                : <Redirect to="/login" />
        )} />
    );
};

export default PrivateRoute;